import clsx from 'clsx'
import type { HTMLAttributes } from 'react'

export default function DataPointsContainer({
  children,
  className,
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        'grid gap-2 sm:grid-cols-2 md:grid-cols-3 md:gap-4 lg:grid-cols-4',
        className
      )}
    >
      {children}
    </div>
  )
}
